module.exports = __webpack_public_path__ + "img/2.70f7dd69.jpg";